import {
  defaultBooleanFilter,
  defaultDateFilter,
  defaultRelationFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';

import {
  OutdoorSectionConfig,
  OutdoorSectionVacancyNotationConfig,
} from '@pigello/pigello-matrix';
import baseFilters, {
  baseGlobalRealEstatesFilter,
  baseTagFilter,
} from '../../filters';
import { Icons } from '@/components/icons';

const outdoorSectionVacancyContractFilter: Filter[] = [
  {
    ...defaultStringFilter,
    title: 'Avtals-ID',
    externalFieldName: 'custom_id',
  },
  {
    ...defaultRelationFilter,
    title: OutdoorSectionVacancyNotationConfig.fields.space.verboseName,
    relationModelName: OutdoorSectionConfig.modelName,
    externalFieldName:
      OutdoorSectionVacancyNotationConfig.fields.space.externalFieldName,
    icon: Icons.outdoorsection,
  },
  {
    ...defaultBooleanFilter,
    title: OutdoorSectionVacancyNotationConfig.fields.automatic.verboseName,
    externalFieldName: 'automatic',
  },
  {
    ...defaultBooleanFilter,
    title: OutdoorSectionVacancyNotationConfig.fields.annulled.verboseName,
    externalFieldName: 'annulled',
  },
  {
    ...defaultDateFilter,
    title: OutdoorSectionVacancyNotationConfig.fields.startDate.verboseName,
    externalFieldName: 'start_date',
  },
  {
    ...defaultDateFilter,
    title: OutdoorSectionVacancyNotationConfig.fields.endDate.verboseName,
    externalFieldName: 'end_date',
  },
  ...baseGlobalRealEstatesFilter,
  ...baseTagFilter,
  ...baseFilters,
];

export default outdoorSectionVacancyContractFilter;
